import { render, staticRenderFns } from "./jssw.vue?vue&type=template&id=1cb5b095&"
import script from "./jssw.vue?vue&type=script&lang=js&"
export * from "./jssw.vue?vue&type=script&lang=js&"
import style0 from "./jssw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports